import { render, staticRenderFns } from "./DrugQuiz.vue?vue&type=template&id=51d4fa53&scoped=true&"
import script from "./DrugQuiz.vue?vue&type=script&lang=js&"
export * from "./DrugQuiz.vue?vue&type=script&lang=js&"
import style0 from "./DrugQuiz.vue?vue&type=style&index=0&id=51d4fa53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d4fa53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
